import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    mb: 3,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 1,
  },
  subtitle: {
    fontSize: "15px",
    color: color.lightText,
  },
  section: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    mb: 2,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: color.text,
    mb: 2,
  },
  label: {
    fontSize: "15px",
    fontWeight: 500,
    color: color.text,
    mb: 1,
  },
  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: color.lightGray,
      },
      "&:hover fieldset": {
        borderColor: color.text,
      },
      "&.Mui-focused fieldset": {
        borderColor: color.primary,
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "15px",
      fontWeight: "400",
      padding: "10px 14px",
    },
  },
  select: {
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: color.lightGray,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: color.text,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: color.primary,
    },
    "& .MuiSelect-select": {
      fontSize: "15px",
      fontWeight: "400",
      padding: "10px 14px",
    },
  },
  datePicker: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  infoText: {
    fontSize: "12px",
    color: color.lightText,
    fontStyle: "italic",
    mt: 1,
  },
  errorText: {
    fontSize: "12px",
    color: color.red,
    mt: 0.5,
    ml: 1.75,
  },
  phoneInputContainer: {
    "& .react-tel-input": {
      width: "100%",
    },
    "& .react-tel-input .form-control": {
      width: "100%",
      height: "42px",
      borderRadius: "8px",
      borderColor: "#E0E0E0",
      fontSize: "14px",
      paddingLeft: "48px",
    },
    "& .react-tel-input .flag-dropdown": {
      borderRadius: "8px 0 0 8px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3,
  },
  submitButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
    "&:disabled": {
      backgroundColor: "#D3D3D3",
      color: "#9E9E9E",
      cursor: "not-allowed",
    },
  },
  cancelButton: {
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    backgroundColor: "#808080",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#6B6B6B",
    },
  },
};

export default style;
